import React, { useRef } from 'react';
import { Box, Typography, Button, Tooltip, IconButton } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const AttivitaToolbar = ({ selectedCount = 0, onGeneraFattura, onNuovaAttivita, onImportAttivita }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        onImportAttivita(file);
        // Reset input so the same file can be re-imported
        e.target.value = '';
    };

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} px={1} flexWrap="wrap" gap={1}>
            <Typography variant="subtitle2" color="text.secondary" fontWeight={600} sx={{ letterSpacing: 1 }}>
                DETTAGLIO ATTIVITÀ
            </Typography>
            <Box display="flex" gap={1} alignItems="center">
                <Tooltip title="Genera una fattura unica per le attività selezionate">
                    <span>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            startIcon={<ReceiptLongIcon />}
                            onClick={onGeneraFattura}
                            disabled={selectedCount === 0}
                            sx={{ textTransform: 'none', borderRadius: 3 }}
                        >
                            Genera fattura{selectedCount > 0 ? ` (${selectedCount})` : ''}
                        </Button>
                    </span>
                </Tooltip>
                <Tooltip title="Importa attività da file JSON">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={() => fileInputRef.current?.click()}
                        sx={{
                            bgcolor: 'rgba(25, 118, 210, 0.08)',
                            '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.2)' },
                            border: '1px solid',
                            borderColor: 'primary.main',
                        }}
                    >
                        <FileUploadIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Aggiungi attività spot">
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        startIcon={<AddIcon />}
                        onClick={onNuovaAttivita}
                        sx={{ textTransform: 'none', borderRadius: 3, px: 3 }}
                    >
                        Nuova Attività
                    </Button>
                </Tooltip>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".json,application/json"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            </Box>
        </Box>
    );
};

export default AttivitaToolbar;